<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">The Last Trumpet</h1>
<p class="subt">A Hugh Rennert Mystery</p>
<p class="subt">Todd Downing<a id="page_1"></a><a id="page_2"></a><a id="page_3"></a><a id="page_4"></a><a id="page_5"></a></p><a id="page_5">
<div class="img_container1">
<img alt="image" src="images/logo3.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?607e1d60